import type { BCCartType } from '@/types/BigCommerce/BCCart'

export const getCartFromExtendInterface = async (): Promise<BCCartType | null> => {
  if (!window.Extend || !window.ExtendBigCommerce) {
    return null
  }

  return new Promise((resolve, reject) => {
    window.ExtendBigCommerce.getCart((error, cart) => (error ? reject(error) : resolve(cart)))
  })
}

export default getCartFromExtendInterface
